namespace Nobox.NoBoxCRM {
    export interface FormpaymentsForm {
        Type: PaymentTypeEditor;
        Name: Serenity.StringEditor;
        Active: ActvEditor;
        Note: Serenity.StringEditor;
        Instruct: Serenity.TextAreaEditor;
        QrCode: Serenity.MultipleImageUploadEditor;
        In: CustomDateTimeEditor;
        Up: CustomDateTimeEditor;
        InBy: Serenity.ServiceLookupEditor;
        UpBy: Serenity.ServiceLookupEditor;
    }

    export class FormpaymentsForm extends Serenity.PrefixedContext {
        static formKey = 'NoBoxCRM.Formpayments';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!FormpaymentsForm.init)  {
                FormpaymentsForm.init = true;

                var s = Serenity;
                var w0 = PaymentTypeEditor;
                var w1 = s.StringEditor;
                var w2 = ActvEditor;
                var w3 = s.TextAreaEditor;
                var w4 = s.MultipleImageUploadEditor;
                var w5 = CustomDateTimeEditor;
                var w6 = s.ServiceLookupEditor;

                Q.initFormType(FormpaymentsForm, [
                    'Type', w0,
                    'Name', w1,
                    'Active', w2,
                    'Note', w1,
                    'Instruct', w3,
                    'QrCode', w4,
                    'In', w5,
                    'Up', w5,
                    'InBy', w6,
                    'UpBy', w6
                ]);
            }
        }
    }
}
